import { useLang } from "../lib/i18n";

export default function Marquee() {
  const { t } = useLang();
  const strip = (ariaHidden) => (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
      {t.marquee.map((item) => (
        <span key={item + (ariaHidden ? "-b" : "-a")} className="flex items-center">
          <span className="font-display font-extrabold text-2xl sm:text-4xl lg:text-5xl tracking-tight text-white/85 px-6 sm:px-10 whitespace-nowrap">
            {item}
          </span>
          <span className="text-gold text-xl sm:text-2xl">✦</span>
        </span>
      ))}
    </div>
  );

  return (
    <section className="marquee-hover border-y border-white/10 bg-panel/60 py-7 sm:py-9 overflow-hidden">
      <div className="flex w-max animate-marquee">
        {strip(false)}
        {strip(true)}
      </div>
    </section>
  );
}
